const EVENT_NAME = 'emitTracking';

export default {
  methods: {
    emitTracking(type = '', ...args) {
      this.$emit(EVENT_NAME, type, args)
    },
  }
}
